<template>
  <div class="m-0 dbozone-font body">
    <div>
      <div class="col-12 justify-content-center d-flex flex-row header-oneboxing">
        <div class="px-1 col-3 p-0">
          <div class="heading-oneboxing">{{ $t("result.round") }}</div>
          <div class="text-subhead-oneboxing">{{ data.roundId }}</div>
        </div>

        <div class="px-1 col-3">
          <div class="heading-oneboxing text-right">
            {{ $t("result.bet") + displayCurrency }}
          </div>
          <div class="text-subhead-oneboxing text-right">
            {{ currentBetAmount | currencyFormatter }}
          </div>
        </div>

        <div class="px-1 col-3">
          <div class="heading-oneboxing text-right">
            {{ $t("result.winlose") + displayCurrency }}
          </div>
          <div class="text-subhead-oneboxing text-right">
            {{ winlose | currencyFormatter }}
          </div>
        </div>

        <div class="px-1 col-3">
          <div class="heading-oneboxing text-right">
            {{ $t("result.balance") + displayCurrency }}
          </div>
          <div class="text-subhead-oneboxing text-right">
            {{ balance | currencyFormatter }}
          </div>
        </div>
      </div>

      <div class="nav-fixed-container">
        <div class="slot-nav nav-fixed-left">
          <i v-if="canGoPrev" class="fas fa-caret-left arrow-side-oneboxing" @click="delCount"></i>
        </div>
        <div class="slot-nav nav-fixed-right">
          <i v-if="canGoNext" class="fas fa-caret-right arrow-side-oneboxing" @click="addCount"></i>
        </div>
      </div>

      <div class="content-bg-wrapper">
        <div class="content-result-oneboxing pt-3">
          <div class="text-games-oneboxing">One Boxing</div>
          <div class="text-subgame-oneboxing">{{ $t("oneboxing.name") }}</div>
          <div class="text-date mb-1">{{ data.timestamp }}</div>

          <div class="col-12 justify-content-center d-flex flex-row py-5">
            <!-- <div class="col-1 d-flex align-items-center justify-content-center slot-nav">
            <i v-if="canGoPrev" class="fas fa-caret-left arrow-side-oneboxing" @click="delCount"></i>
          </div> -->

            <div v-if="this.state != 'SETUPFREESPIN'" class="slot-wrapper" ref="slotWrapper">
              <img :src="boardBackground" class="slot-layer slot-layer-bg" alt="" />

              <div class="slot-container p-2">
                <div v-for="(reelGroup, reelIndex) in reels" :key="reelIndex" class="reel-column">
                  <div v-for="(reel, index) in reelGroup" :key="index" class="reel-symbol">
                    <img v-if="reel >= 0 && reel <= 11" class="icon-symbol-oneboxing"
                      :class="symbolsWin.length === 0 ? 'normal' : symbolsWin.includes(reel) ? 'highlight' : 'hide'"
                      :src="getSymbolSrc(reel)" alt="" />
                  </div>
                  <div v-if="reelsMultiplier[reelIndex] != null" class="wild-reel-overlay">
                    <div v-if="reelsMultiplier[reelIndex].name === 'WM'">
                      <img class="icon-wild-oneboxing" :src="getWildSrc('WM')" alt="" />
                    </div>

                    <div
                      v-else-if="reelsMultiplier[reelIndex].name === 'WG' || reelsMultiplier[reelIndex].name === 'WGC'">
                      <img class="icon-wild-oneboxing" :src="getWildSrc(reelsMultiplier[reelIndex].name)" alt="" />
                    </div>

                    <div v-if="reelsMultiplier[reelIndex].multiplier > 1" class="font"
                      :style="{ transform: `translateX(-50%) scale(${fontScale})` }">
                      <span
                        v-for="(multiplierClass, multiplierIndex) in getMultiplierClasses(reelsMultiplier[reelIndex].multiplier)"
                        :key="multiplierIndex" :class="multiplierClass"></span>
                    </div>
                  </div>
                </div>
              </div>

              <img :src="boardForeground" class="slot-layer slot-layer-fg" alt="" />
            </div>

            <div v-if="this.state === 'SETUPFREESPIN'" class="stack">
              <img
                :src="`${require(`../../assets/resultGame/oneboxing/wheel_buyfeature_${freeSpinData.mode === 1 ? 'normal' : 'super'}_bg.png`)}`"
                class="layer-bg" alt="" :style="{ transform: `rotate(${getSpinAngle(freeSpinData)}deg)` }" />
              <img
                :src="`${require(`../../assets/resultGame/oneboxing/wheel_buyfeature_${freeSpinData.mode === 1 ? 'normal' : 'super'}_mg.png`)}`"
                class="layer-bg " alt="" :style="{ transform: `rotate(${getMultipleirAngle(freeSpinData)}deg)` }" />
              <img
                :src="`${require(`../../assets/resultGame/oneboxing/wheel_buyfeature_${freeSpinData.mode === 1 ? 'normal' : 'super'}_fg.png`)}`"
                class="layer-bg " alt="" />
              <img
                :src="`${require(`../../assets/resultGame/oneboxing/arrow_buyfeature_${freeSpinData.mode === 1 ? 'normal' : 'super'}.png`)}`"
                class="layer-arrow " alt="" />
            </div>
          </div>

          <div v-if="this.state === 'FREERESPIN'" class=" text-center text-games-oneboxing"
            style="font-size: 1rem; color:#FFF;">
            {{ }} RESPIN
          </div>
          <div class=" text-center py-4 text-games-oneboxing">
            {{ stepTitle }}
          </div>

          <div v-if="data.detail.featureBuy" class=" text-center py-2" style="font-size: 1rem; color:#FFF;">
            {{ $t("featurebuy.title") }} : {{ freeSpinData.mode === 1 ? 'NORMAL FREESPIN' : 'SUPER FREESPIN' }}
          </div>

          <div v-if="this.isFreespin && !data.detail.featureBuy" class=" text-center py-2"
            style="font-size: 1rem; color:#FFF;">
            {{ freeSpinData.mode === 1 ? 'NORMAL FREESPIN' : 'SUPER FREESPIN' }}
          </div>


          <div v-if="multiplier > 1">
            <div class="text-center py-2 text-games-oneboxing" style="font-size: 1.3rem;">
              {{ $t("result.multiply") }} x {{ multiplier }}
            </div>
          </div>

          <div v-if="winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
            <hr class="line col-3" />
            <div class="text-detail align-items-center d-flex px-3">
              {{ $t("result.detail") }}
            </div>
            <hr class="line col-3" />
          </div>

          <div v-if="this.state === 'SETUPFREESPIN'">
            <div class="row display-flex justify-content-center py-3" style="padding-left: 15%; padding-right: 15%;">
              <div class="col-6 text-left">
                <h1 class="green" style="font-size: 1.5rem;">{{ $t("result.freespin") }}</h1>
              </div>
              <div class="col-6 text-right">
                <h1 class="green" style="font-size: 1.5rem;">{{ freeSpinData.amount }}</h1>
              </div>
            </div>
            <div class="row display-flex justify-content-center py-3" style="padding-left: 15%; padding-right: 15%;">
              <div class="col-6 text-left">
                <h1 class="green" style="font-size: 1.5rem;">{{ $t("result.multiply") }}</h1>
              </div>
              <div class="col-6 text-right">
                <h1 class="green" style="font-size: 1.5rem;">X{{ freeSpinData.multiplier }}</h1>
              </div>
            </div>
          </div>


          <div class="col-12 justify-content-start d-flex flex-row">
            <div class="p-2 px-3 justify-content-start align-items-center container">

              <div v-if="retrigger && scatterCount === 3">
                <div class="bet-wrapper justify-content-between item d-flex flex-row col-12 pt-2">
                  <div class="d-flex flex-row">
                    <div style="margin-left:10px" class="d-flex text-win align-items-center justify-content-center">
                      <img class="icon-detail-oneboxing" :src="getSymbolSrc(9)" alt="" />

                      <p class="my-1 pl-4">
                        <span class="multiplier-text">{{ ` X${scatterCount}` }}</span>
                        <span class="my-1 green" style="padding-left: 20px;">
                          ({{ `${freespinCount} ` + $t("result.freespin") }})
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="winnings.length > 0">
                <div v-for="(detail, index) in winnings" :key="index"
                  class="bet-wrapper justify-content-between item d-flex flex-row col-12 pt-2">
                  <div class="d-flex flex-row">
                    <div style="margin-left:10px" class="d-flex text-win align-items-center justify-content-center">
                      <img class="icon-detail-oneboxing" :src="getSymbolSrc(detail.symbol)" alt="" />
                      <div class="text-multiplier d-flex flex-column justify-content-center align-items-left">
                        <span v-if="detail.symbol !== 10 && detail.symbol !== 11" class="my-1 green"
                          style="padding-left: 10px; text-align: left;">
                          {{ $t("result.line") + ': ' + (detail.line + 1) }}
                        </span>
                        <span class="my-1 green" style="padding-left: 10px; color: darkgray; text-align: left;">
                          {{ detail.count }} {{ $t("result.kind") }} = {{ detail.amount / detail.multiplier |
                            currencyFormatter }}
                          {{ detail.multiplier > 1 ? 'X' + detail.multiplier : '' }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex text-win justify-content-center align-items-center px-1">
                    <p class="my-1 green" style="text-align: right;">
                      {{ displayCurrency }} {{ detail.amount | currencyFormatter }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";

export default {
  name: "result-oneboxing",
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      }
    },
    page: {
      type: Number,
      default: 0
    },
    isback: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t),

      date: "",
      time: "",
      currentIndex: 0,

      currency: this.data && this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data && this.data.rateCurrency ? this.data.rateCurrency : 1,

      isFreespin: false,
      isGamble: false,
      isEndRound: false,

      state: "",
      nextState: "",

      multiplier: 0,
      reels: [],
      reelSizes: [],
      reelsMultiplier: [],

      retrigger: false,
      scatterCount: 0,
      freespinFirstRound: false,
      freespinCount: 0,
      winAmounts: 0,
      symbolsWin: [],
      fontScale: 0.25,

      freeSpinData: null,
      winlose: 0,
      bet: 0,
      balance: 0,
      winnings: []
    };
  },
  computed: {
    summaryList: function () {
      var detail = this.data && this.data.detail ? this.data.detail : null;
      return detail && detail.summary ? detail.summary : [];
    },
    getCounttotalSteps() {
      return this.summaryList.length;
    },
    currentStep: function () {
      return this.summaryList[this.currentIndex] || null;
    },
    displayCurrency: function () {
      if (this.currentStep && this.currentStep.isCoin) return "AMS";
      if (this.tokenData && this.tokenData.isSymb === false) return "";
      return this.currency.includes("(") ? this.currency : "(" + this.currency + ")";
    },
    currentBetAmount: function () {
      if (this.currentIndex === 0) return this.data && this.data.bet ? this.data.bet : 0;
      return this.currentStep && this.currentStep.bet ? this.currentStep.bet.amount || 0 : 0;
    },
    canGoPrev: function () {
      return this.isFreespin || this.isGamble || this.currentIndex > 0;
    },
    canGoNext: function () {
      return !this.isEndRound;
    },
    getCount: function () {
      let spinList = this.summaryList.filter(item => item.state === "SPIN" || item.state === "RESPIN").length;
      let freeList = this.summaryList.filter(item => item.state === "FREESPIN").length;
      return this.state === "FREESPIN" || this.state === "FREERESPIN" || this.state === "SETUPFREESPIN" ? freeList : spinList;
    },
    stepTitle: function () {
      if (this.state === "SETUPFREESPIN")
        return "GAMBLE"
      else {
        let round = this.isFreespin ? this.freeSpinData.round : this.currentStep.round;
        let state = this.state === "FREERESPIN" ? "FREESPIN" : this.state;
        return state + " " + round + "/" + this.getCount;
      }
    },
    boardBackground: function () {
      const type = this.isFreespin ? "free" : "normal";
      return require("../../assets/resultGame/oneboxing/slotmachine_" + type + "_bg.png");
    },
    boardForeground: function () {
      const type = this.isFreespin ? "free" : "normal";
      return require("../../assets/resultGame/oneboxing/slotmachine_" + type + "_fg.png");
    }
  },
  created: function () {
    this.currentIndex = this.isback ? Math.max(this.totalSteps - 1, 0) : 0;
    this.syncCurrentStep();
  },
  mounted: function () {
    this.updateFontScale();
    window.addEventListener("resize", this.updateFontScale);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.updateFontScale);
  },
  methods: {
    updateFontScale: function () {
      var self = this;
      this.$nextTick(function () {
        var wrapper = self.$refs.slotWrapper;
        if (wrapper) {
          // colWidth ≈ wrapper / 6 columns; base: scale 0.25 when colWidth = 134px
          var colWidth = wrapper.offsetWidth / 6;
          self.fontScale = colWidth / (134 * 4);
        }
      });
    },

    onResize: function () {
      var header = document.getElementsByClassName("header-oneboxing")[0];
      this.headerHeight = header ? header.offsetHeight : 0;
    },

    syncCurrentStep: function () {
      if (!this.currentStep) return;
      this.mapSymbol(this.currentStep);
    },

    mapSymbol: function (result) {
      var freeSpin = result && result.freeSpin ? result.freeSpin : {};
      this.currentData = result;


      this.freeSpinData = freeSpin;

      this.isGamble = result.state === "GAMBLE";
      this.isFreespin = result.state === "FREESPIN" || result.state === "FREERESPIN" || result.state === "SETUPFREESPIN";

      this.state = result.state || "";
      this.nextState = result.nextState || "";

      this.reelSizes = result.reelSizes || [];
      this.reelsMultiplier = this.checkMultiplerReels(result);
      this.multiplier = result.multiplier || 0;

      this.retrigger = !!freeSpin.retrigger;
      this.freespinFirstRound = freeSpin.round === 0;
      this.scatterCount = 0;
      this.freespinCount = this.retrigger
        ? (freeSpin.retrigger || 0)
        : (freeSpin.remain || 0);
      this.winAmounts = result.winAmounts || 0;

      (result.reels || []).forEach(function (row) {
        (row || []).forEach(function (num) {
          if (num === 11) {
            this.scatterCount += 1;
          }
        }, this);
      }, this);

      this.reels = result.finalReels || [];
      this.isEndRound = !!result.isEndRound;
      this.winlose = result.win || 0;
      this.bet = result.bet || 0;
      this.balance = result.balance || 0;
      this.winnings = result.winnings || [];
    },

    addCount: function () {
      var nextIndex = this.currentIndex + 1;

      if (nextIndex > this.totalSteps - 1) {
        this.$emit("fetchResult", this.page + 1);
        return;
      }

      this.currentIndex = nextIndex;
      this.syncCurrentStep();
    },

    delCount: function () {
      var prevIndex = this.currentIndex - 1;

      if (prevIndex < 0) {
        if (this.page > 0) {
          this.$emit("fetchResult", this.page - 1, true);
        }
        return;
      }

      this.currentIndex = prevIndex;
      this.syncCurrentStep();
    },

    checkMultiplerReels: function (result) {
      var reels = result.finalReels || [];
      var wildReels = result.wildReels || [];
      var wildMulReels = result.wildMulReels || [];
      let resultWildReels = [];

      for (let i = 0; i < reels.length; i++) {
        let wilds = reels[i].every(symbol => symbol === 9);
        if (wilds) {
          resultWildReels.push({
            name: wildReels[i],
            reels: i,
            multiplier: wildMulReels[i]
          });
        }
        else {
          resultWildReels.push(null);
        }

      }
      return resultWildReels;
    },

    getSymbolSrc: function (symbol) {
      return require("../../assets/resultGame/oneboxing/s_" + symbol + ".png");
    },

    getWildSrc: function (type) {
      if (type === "WM") {
        return require("../../assets/resultGame/oneboxing/wild_gold_2_a.png");
      } else {
        return require("../../assets/resultGame/oneboxing/wild_gold_2_b.png");
      }
    },

    getMultiplierClasses: function (multiplier) {
      if (multiplier == null || multiplier <= 1) {
        return [];
      }
      var value = String(multiplier);
      var classes = ["cx"];
      for (var i = 0; i < value.length; i++) {
        var char = value.charAt(i);

        if (char >= "0" && char <= "9") {
          classes.push("c" + char);
        }
      }
      return classes;
    },

    getSpinAngle: function (freeData) {
      let spin_free_angle = {
        5: [0, -144, -192, -264, -312],
        8: [-48, -96, -240, -336],
        10: [-72, -120, -288],
        12: [-24, -168, -216],
      }

      let spin_super_angle = {
        10: [0, -144, -192, -264, -312],
        15: [-48, -96, -240, -336],
        20: [-72, -120, -288],
        25: [-24, -168, -216],
      }

      let amount = freeData.amount;
      if (freeData.mode === 1) {
        let data = spin_free_angle[amount].length;
        let deg = spin_free_angle[amount][Math.floor(Math.random() * data)];
        return Math.abs(deg);
      } else if (freeData.mode === 2) {
        let data = spin_super_angle[amount].length;
        let deg = spin_super_angle[amount][Math.floor(Math.random() * data)];
        return Math.abs(deg);
      }
    },
    getMultipleirAngle: function (freeData) {
      let multiplier_free_angle = {
        2: [72, 120, 240],
        3: [0, 312],
        5: [144, 336],
        8: [168],
        10: [216],
        15: [48, 96, 264],
        20: [24, 192],
        25: [288]
      }
      let multiplier_super_angle = {
        4: [72, 120, 240],
        6: [0, 312],
        10: [144, 336],
        20: [168, 216],
        30: [48, 96, 264],
        50: [24, 192],
        100: [288]
      }

      let multiplier = freeData.multiplier;
      if (freeData.mode === 1) {
        let data = multiplier_free_angle[multiplier].length;
        let deg = multiplier_free_angle[multiplier][Math.floor(Math.random() * data)];
        return -Math.abs(deg);
      } else if (freeData.mode === 2) {
        let data = multiplier_super_angle[multiplier].length;
        let deg = multiplier_super_angle[multiplier][Math.floor(Math.random() * data)];
        return -Math.abs(deg);
      }
    }
  }
};
</script>

<style scoped>
/* =========================
   Base
========================= */
body {
  font-family: "Prompt", sans-serif;
  background-color: #172019;
}

img {
  display: block;
  pointer-events: none;
  cursor: default;
}

/* =========================
   Header
========================= */
.header-oneboxing {
  background: #ffaa00;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-oneboxing>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-oneboxing {
  color: #fff;
  text-align: center;
  font-size: 1rem;
}

/* =========================
   Content / Text
========================= */
.content-bg-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #323232;
}

.content-result-oneboxing {
  width: 80%;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
}

.text-games-oneboxing,
.text-collect-oneboxing,
.text-subhead-oneboxing,
.text-date,
.text-detail {
  color: #fff;
  text-align: center;
}

.text-games-oneboxing,
.text-collect-oneboxing {
  font-size: 25px;
}

.text-subhead-oneboxing,
.text-date {
  font-size: 1rem;
}

.text-subgame-oneboxing {
  font-size: 20px;
  color: #ffaa00;
  text-align: center;
}

.text-detail {
  font-size: 20px;
}

.text-multiplier {
  width: 100%;
  text-align: center;
}

.line,
.multiplier-text {
  color: #ffaa00;
}

.line {
  width: 100%;
  height: 2px;
  background-color: #fff;
  font-size: 28px;
}

.green {
  color: #fff;
  font-size: 28px;
}

.red {
  color: #ff0000;
}

/* =========================
   Navigation
========================= */
.slot-nav {
  color: #fff;
}

.arrow-side-oneboxing {
  cursor: pointer;
  color: #fff;
  text-align: center;
  font-size: 70px;
}

/* =========================
   Slot Board Layers
========================= */
.slot-wrapper {
  position: relative;
  width: 80%;
  margin: 0 auto;
  line-height: 0;
}

.slot-layer {
  display: block;
  width: 100%;
  height: auto;
}

.slot-layer-bg {
  position: relative;
  z-index: 1;
}

.slot-layer-fg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: auto;
  pointer-events: none;
}

/* =========================
   Slot Grid
========================= */
.slot-container {
  position: absolute;
  top: 4.8%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;

  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 3%;
  width: 96%;
  height: 90%;
}

.reel-column {
  position: relative;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  height: 100%;
}

.reel-symbol {
  flex: 1 1 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
}

.icon-symbol-oneboxing {
  display: block;
  width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* =========================
   Wild Overlay
========================= */
.wild-reel-overlay {
  position: absolute;
  inset: 0;
  z-index: 4;
  pointer-events: none;
  overflow: visible;
}

.icon-wild-oneboxing {
  position: absolute;
  top: 0;
  left: 2%;
  top: 5%;
  width: 100%;
  scale: 1.2;
  ;
  object-fit: fill;
}


/* ============================================================
   Font Number Display
   ============================================================ */
.font {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%) scale(0.25);
  /* fallback; overridden by :style binding */
  transform-origin: bottom center;

  display: flex;
  align-items: flex-end;

  z-index: 6;
  pointer-events: none;
}

.font span {
  display: inline-block;
  background-image: url("../../assets/resultGame/oneboxing/font_number.png");
  background-repeat: no-repeat;
  margin-right: -40px;
}

.c9 {
  width: 134px;
  height: 198px;
  background-position: -50px -50px;
}

.c6 {
  width: 134px;
  height: 198px;
  background-position: -250px -50px;
}

.c8 {
  width: 134px;
  height: 198px;
  background-position: -420px -50px;
}

.c0 {
  width: 134px;
  height: 198px;
  background-position: -610px -50px;
}

.c3 {
  width: 134px;
  height: 198px;
  background-position: -800px -50px;
}

.c5 {
  width: 134px;
  height: 198px;
  background-position: -50px -300px;
}

.c2 {
  width: 134px;
  height: 198px;
  background-position: -250px -300px;
}

.cx {
  width: 134px;
  height: 198px;
  background-position: -420px -300px;
}

.c4 {
  width: 134px;
  height: 198px;
  background-position: -610px -300px;
}

.c7 {
  width: 134px;
  height: 198px;
  background-position: -50px -550px;
}

.c1 {
  width: 134px;
  height: 198px;
  background-position: -250px -550px;
}

.cdot {
  width: 54px;
  height: 66px;
  background-position: -880px -785px;
}

/* =========================
   Responsive
========================= */
@media (min-width: 1366px) {
  .slot-wrapper {
    width: 50%;
  }
}

@media (max-width: 1024px) {
  .slot-wrapper {
    width: 88%;
  }

  .slot-container {
    top: 3.3%;
    height: 90.5%;
    gap: 2.5%;
  }
}

@media (max-width: 768px) {
  .slot-wrapper {
    width: 94%;
  }

  .slot-container {
    top: 3.4%;
    height: 91%;
    gap: 2%;
  }
}

@media (max-width: 480px) {
  .slot-wrapper {
    width: 100%;
  }

  .slot-container {
    top: 3.6%;
    height: 91.5%;
    gap: 1.5%;
  }

  .text-subhead-oneboxing {
    font-size: 0.7rem;
  }

  .heading-oneboxing {
    font-size: 0.7rem;
  }
}

.stack {
  position: relative;
  width: 60%;
  aspect-ratio: 1 / 1;
  /* ปรับตามสัดส่วนรูป wheel จริง เช่น 4/3 หรือ 16/9 */
  margin: 5% auto;
  line-height: 0;
}

.layer-arrow {
  transform: translate(455%, -55%);
  max-width: 10%;
}

/* style พื้นฐานของ layer */
.stack img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
}

@media (min-width: 1366px) {
  .stack {
    width: 50%;
  }
}

@media (max-width: 1024px) {
  .stack {
    width: 88%;
  }
}

@media (max-width: 768px) {
  .stack {
    width: 94%;
  }
}

@media (max-width: 480px) {
  .stack {
    width: 100%;
  }
}

.icon-detail-oneboxing {
  max-width: 35%;
  height: auto;
}

/* =========================
   Fixed Navigation
========================= */
.nav-fixed-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 999;
}

.nav-fixed-left,
.nav-fixed-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: all;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-fixed-left {
  left: 10px;
}

.nav-fixed-right {
  right: 10px;
}
</style>